'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:ModalProductEditCtrl
 * @description
 * # ModalProductEditCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('ModalProductEditCtrl', function ($scope, api, storeUtils, product) {
		if (!product.versions) {
			product.versions = [];
		}

		if (product.versions.length === 0) {
			product.versions.push({
				name: '1.0',
				featured: true
			});
		}
		$scope.product = product;
		/**
		 * @type {{selectedVersion: ProductVersion, selectedVariant: ProductVariant | null, showAllVariants:boolean}}
		 */
		$scope.tmp = {
			selectedVersion: product.versions.slice(-1).pop(),
			selectedVariant: null,
			showAllVariants: false,
		};

		$scope.selectedVersionVariantsFeatured = () => {
			if (!$scope.tmp.selectedVersion) {
				return [];
			}
			if ($scope.tmp.showAllVariants) {
				return $scope.tmp.selectedVersion.variants;
			}
			return storeUtils.memoizeMetadata($scope.tmp.selectedVersion, 'variantsFeatured', (/*ProductVersion*/ version) => {
				return version.variants.filter(variant => variant.featured);
			})
		};

		$scope.versionAdd = () => {
			if (!window.confirm('WARNING! You probably want to increment the version number on an existing version instead of adding a new version. Are you SURE you want to add a new version?')) {
				return;
			}
			const maxVersion = Math.max(...$scope.product.versions.map(v => v.versionNumber));
			/**
			 * @type {ProductVersion}
			 */
			let newVersion = {
				variants: [],
				versionNumber: (maxVersion || 0) + 1,
			};
			$scope.product.versions.push(newVersion);
			$scope.tmp.selectedVersion = newVersion;
		};

		/**
		 * @param version {ProductVersion}
		 */
		$scope.variantAdd = (version) => {
			/**
			 * @type {ProductVariant}
			 */
			let newVariant = {};
			version.variants.push(newVariant);
			$scope.variantEdit(newVariant);
		};

		/**
		 * @param variant {ProductVariant}
		 */
		$scope.variantEdit = async function (variant) {
			// hack: throw the version on the upgrade_from if present. Version wasn't included in the JSON for version.variants.
			if (variant?.upgradeFromVariant) {
				/**
				 * @type ProductVariant
				 */
				let upgradeFromRefresh = await api.get('api/variant-detail', {params: {variantId: variant.upgradeFromVariant.id}});
				variant.upgradeFromVariant.version = upgradeFromRefresh.version;
			}
			$scope.tmp.selectedVariant = variant;
		};

		$scope.quickSearchVariantsForUpgradeFrom = function (q) {
			const params = {q: q};
			if (!$scope.showAllVariants) {
				params.productId = $scope.product.id;
			}
			return api.get('api/quicksearch-variant', {params: params})
				.then(found => found.filter(/**ProductVariant[]*/ pv => !pv.upgradeFromVariant)); // cannot upgrade from another upgrade, filter them out
		};

		$scope.variantDone = function () {
			$scope.tmp.selectedVariant = null;
		};

		$scope.variantDownload = function (variant) {
			window.alert('Download not implemented for ' + variant);
		};

		$scope.save = function () {
			api.saveProduct(product)
				.then(function (saved) {
					$scope.$close(saved);
				});
		};
	});
